import styled from 'styled-components';
import { Form, Button, Card as AntCard, Table } from 'antd';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  background: linear-gradient(135deg, #1A1D23 0%, #1a1d26 25%, #0f1115 50%, #1a1d26 75%, #1A1D23 100%);
  position: relative;
  padding: 0;
  display: flex;
  flex-direction: column;
  margin: 0;
`;

export const PageHeader = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.sm};
  position: relative;
  z-index: 1;
  padding: ${({ theme }) => theme.spacing.lg};
  padding-bottom: ${({ theme }) => theme.spacing.md};
`;

export const PageTitle = styled.h1`
  font-size: ${({ theme }) => theme.fontSize.lg};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0 0 ${({ theme }) => theme.spacing.sm} 0;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
`;

export const PageSubtitle = styled.p`
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0;
`;

export const FormContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

export const Card = styled(AntCard)`
  background-color: ${({ theme }) => theme.colors.background.secondary};
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  border-radius: 4px;
  
  .ant-card-head {
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};
    color: ${({ theme }) => theme.colors.text.primary};
    font-size: 14px;
    font-weight: 600;
    padding: 6px 10px;
    min-height: 32px;
    flex-shrink: 0;
  }

  .ant-card-body {
    padding: 10px;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }
`;

export const FormCard = styled(AntCard)`
  background: ${({ theme }) => theme.colors.background.secondary};
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  border-radius: 4px;
  box-shadow: none;
  
  .ant-card-body {
    padding: 10px;
  }
`;

export const FormSection = styled.div`
  margin-bottom: 12px;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};
    padding-bottom: 12px;
  }
`;

export const SectionTitle = styled.h2`
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 4px 0;
  display: flex;
  align-items: center;
`;

export const SectionDescription = styled.p`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 12px;
  margin: 0 0 8px 0;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FormItem = styled(Form.Item)`
  margin-bottom: 6px;

  .ant-form-item-label {
    padding-bottom: 0 !important;
  }

  .ant-input-number-handler-wrap {
    display: none !important;
  }

  .ant-form-item-label > label {
    color: ${({ theme }) => theme.colors.text.secondary};
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.sm};
  }
  
  .ant-input,
  .ant-input-number,
  .ant-select-selector,
  .ant-picker {
    background: ${({ theme }) => theme.colors.background.tertiary} !important;
    border-color: ${({ theme }) => theme.colors.border.primary} !important;
    color: ${({ theme }) => theme.colors.text.primary} !important;

    &:hover {
      border-color: ${({ theme }) => theme.colors.primary} !important;
    }

    &:focus,
    &.ant-input-focused {
      border-color: ${({ theme }) => theme.colors.primary} !important;
      box-shadow: 0 0 0 2px rgba(14, 203, 129, 0.2) !important;
    }
  }

  .ant-input-number-focused {
    border-color: ${({ theme }) => theme.colors.primary} !important;
    box-shadow: 0 0 0 2px rgba(14, 203, 129, 0.2) !important;
  }

  .ant-select-focused .ant-select-selector {
    border-color: ${({ theme }) => theme.colors.primary} !important;
    box-shadow: 0 0 0 2px rgba(14, 203, 129, 0.2) !important;
  }
  
  .ant-input-number-handler-wrap {
    background: ${({ theme }) => theme.colors.background.tertiary};
    border-left-color: ${({ theme }) => theme.colors.border.primary};
  }
  
  .ant-input-number-handler {
    border-color: ${({ theme }) => theme.colors.border.primary};
    
    &:hover {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
  
  .ant-switch {
    background: ${({ theme }) => theme.colors.background.tertiary};
    
    &.ant-switch-checked {
      background: ${({ theme }) => theme.colors.primary};
    }
  }
  
  .ant-select-arrow,
  .ant-input-number-handler-up-inner,
  .ant-input-number-handler-down-inner {
    color: ${({ theme }) => theme.colors.text.secondary};
  }
  
  .ant-select-selection-placeholder {
    color: ${({ theme }) => theme.colors.text.tertiary};
  }
`;

export const VolumeRangeTable = styled.div`
  margin-top: 0;
  
  .ant-table {
    .ant-table-tbody > tr > td {
      color: ${({ theme }) => theme.colors.text.primary};
    }
    
    .ant-btn {
      color: ${({ theme }) => theme.colors.text.primary} !important;
      
      &.ant-btn-dangerous {
        color: ${({ theme }) => theme.colors.trading.sell} !important;
        
        &:hover:not(:disabled) {
          color: ${({ theme }) => theme.colors.trading.sell} !important;
          background: rgba(246, 70, 93, 0.1) !important;
        }
      }
      
      &:hover:not(:disabled) {
        color: ${({ theme }) => theme.colors.trading.buy} !important;
        background: rgba(14, 203, 129, 0.1) !important;
      }
    }
  }
`;

export const AddRangeButton = styled.div`
  margin-top: ${({ theme }) => theme.spacing.sm};
  flex-shrink: 0;
  
  .ant-btn-dashed {
    border-color: ${({ theme }) => theme.colors.trading.buy};
    color: ${({ theme }) => theme.colors.trading.buy};
    background: transparent;
    
    &:hover:not(:disabled) {
      border-color: ${({ theme }) => theme.colors.trading.buy};
      color: ${({ theme }) => theme.colors.trading.buy};
      background: rgba(14, 203, 129, 0.1);
    }
    
    &:focus:not(:disabled) {
      border-color: ${({ theme }) => theme.colors.trading.buy};
      color: ${({ theme }) => theme.colors.trading.buy};
    }
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing.md};
  margin-top: ${({ theme }) => theme.spacing.xl};
  padding-top: ${({ theme }) => theme.spacing.xl};
  
  @media (max-width: 768px) {
    flex-direction: column-reverse;
    
    button {
      width: 100%;
    }
  }
`;

export const SubmitButton = styled(Button)`
  background: ${({ theme }) => theme.colors.trading.buy} !important;
  border-color: ${({ theme }) => theme.colors.trading.buy} !important;
  color: #ffffff !important;
  font-weight: 600;
  height: 28px;
  font-size: ${({ theme }) => theme.fontSize.sm};
  border-radius: 4px;
  padding: 0 14px;
  min-width: fit-content;
  
  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.trading.buy} !important;
    border-color: ${({ theme }) => theme.colors.trading.buy} !important;
    opacity: 0.9 !important;
    color: #ffffff !important;
  }
  
  &:focus:not(:disabled) {
    background: ${({ theme }) => theme.colors.trading.buy} !important;
    border-color: ${({ theme }) => theme.colors.trading.buy} !important;
    color: #ffffff !important;
    box-shadow: 0 0 0 2px rgba(14, 203, 129, 0.2) !important;
  }
  
  &:active:not(:disabled) {
    background: ${({ theme }) => theme.colors.trading.buy} !important;
    border-color: ${({ theme }) => theme.colors.trading.buy} !important;
    color: #ffffff !important;
  }
  
  &:disabled {
    background: ${({ theme }) => theme.colors.trading.buy} !important;
    border-color: ${({ theme }) => theme.colors.trading.buy} !important;
    color: #ffffff !important;
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const CancelButton = styled(Button)`
  background: ${({ theme }) => theme.colors.background.secondary} !important;
  border-color: ${({ theme }) => theme.colors.border.secondary} !important;
  color: ${({ theme }) => theme.colors.text.primary} !important;
  font-weight: 500;
  height: 30px;
  font-size: ${({ theme }) => theme.fontSize.lg};
  border-radius: 4px;
  padding: 12px 24px;
  
  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.colors.trading.buy} !important;
    color: ${({ theme }) => theme.colors.trading.buy} !important;
    background: rgba(14, 203, 129, 0.1) !important;
  }
  
  &:focus:not(:disabled) {
    border-color: ${({ theme }) => theme.colors.trading.buy} !important;
    color: ${({ theme }) => theme.colors.trading.buy} !important;
    box-shadow: 0 0 0 2px rgba(14, 203, 129, 0.1) !important;
  }
`;

// Grid Layout Components
export const GridLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 2fr) 400px;
  gap: ${({ theme }) => theme.spacing.sm};
  height: calc(100vh - 250px);
  min-height: calc(100vh - 250px);
  margin-right: ${({ theme }) => theme.spacing.lg};

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
    grid-template-rows: auto 600px 300px;
    height: auto;
    margin-right: 0;
  }
`;

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm};
  height: 100%;
  overflow: hidden;
  min-height: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    height: auto;
    overflow: visible;
  }
`;

export const CenterColumn = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: ${({ theme }) => theme.spacing.sm};
  overflow: hidden;
  min-height: 0;
`;

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm};
  height: 100%;
  width: 100%;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
`;

export const ChartContainer = styled.div<{ $height?: number }>`
  width: 100%;
  height: 100%;
  flex: 1;
  min-height: 0;
  background-color: ${({ theme }) => theme.colors.background.secondary};
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  border-radius: 4px;
  overflow: hidden;
`;

export const CompactCard = styled(Card)`
  background-color: ${({ theme }) => theme.colors.background.secondary};
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  
  .ant-card-head {
    padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.sm};
    min-height: 36px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};
    color: ${({ theme }) => theme.colors.text.primary};
    
    .ant-card-head-title {
      font-size: ${({ theme }) => theme.fontSize.sm};
      padding: 0;
    }
  }
  
  .ant-card-body {
    padding: ${({ theme }) => theme.spacing.sm};
  }
`;

export const CompactStatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${({ theme }) => theme.spacing.sm};
`;

export const CompactStatItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs};
`;

export const CompactStatLabel = styled.div`
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: ${({ theme }) => theme.spacing.xs};
`;

export const CompactStatValue = styled.div<{ $color?: 'buy' | 'sell' | 'warning' | 'neutral' }>`
  font-size: ${({ theme }) => theme.fontSize.md};
  font-weight: 600;
  color: ${({ theme, $color = 'neutral' }) => {
    switch ($color) {
      case 'buy': return theme.colors.trading.buy;
      case 'sell': return theme.colors.trading.sell;
      case 'warning': return theme.colors.trading.warning;
      default: return theme.colors.text.primary;
    }
  }};
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: ${({ theme }) => theme.spacing.xl};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.fontSize.md};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const PriceDisplay = styled.span`
  font-family: 'Courier New', monospace;
  font-size: ${({ theme }) => theme.fontSize.md};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const ChangeDisplay = styled.span<{ positive: boolean }>`
  font-family: 'Courier New', monospace;
  font-size: ${({ theme }) => theme.fontSize.base};
  font-weight: 600;
  color: ${({ theme, positive }) => 
    positive ? theme.colors.trading.up : theme.colors.trading.down
  };
`;

export const PortfolioSelectorWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  margin-bottom: ${({ theme }) => theme.spacing.xs};
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.sm};
  background: ${({ theme }) => theme.colors.background.secondary};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  position: relative;
  z-index: 1;
`;

export const PortfolioLabel = styled.span`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: 600;
  white-space: nowrap;
`;

export const PortfolioSelect = styled.div`
  flex: 1;
  max-width: 400px;

  .ant-select {
    width: 100%;
  }

  .ant-select-selector {
    background: ${({ theme }) => theme.colors.background.primary} !important;
    border: 1px solid ${({ theme }) => theme.colors.border.primary} !important;
    color: ${({ theme }) => theme.colors.text.primary} !important;
    
    &:hover {
      border-color: ${({ theme }) => theme.colors.primary} !important;
    }
  }

  .ant-select-focused .ant-select-selector {
    border-color: ${({ theme }) => theme.colors.primary} !important;
    box-shadow: 0 0 0 2px rgba(14, 203, 129, 0.1) !important;
  }

  .ant-select-arrow {
    color: ${({ theme }) => theme.colors.text.secondary};
  }
`;

